import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { label: "About CCF", href: "#about" },
  { label: "Advantages", href: "#advantage" },
  { label: "Partner Farms", href: "#farms" },
  { label: "How It Works", href: "#how" },
  { label: "Member Stories", href: "#stories" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={[
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300",
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent",
      ].join(" ")}
    >
      <div className="w-full px-6 md:px-10 lg:px-14">
        <div className="flex items-center justify-between h-20">
          <a href="#top" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://storage.helloreaddy.io/project_files/6a6310ba-0547-4942-a5e0-6c602507315a/4ff0e6c9-817e-4060-8942-21370fe415ed_compressed_t.webp"
              alt="CCF DAIRY"
              className="h-10 md:h-12 w-auto object-contain"
            />
            <span
              className={[
                "hidden md:inline text-sm md:text-base font-heading font-medium tracking-tight leading-tight",
                scrolled ? "text-foreground-900" : "text-background-50",
              ].join(" ")}
              style={{ fontFamily: "Fraunces, serif" }}
            >
              Co-Creation Farm
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-9">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={[
                  "text-sm font-medium transition-colors cursor-pointer whitespace-nowrap",
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-50/90 hover:text-background-50",
                ].join(" ")}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="https://dna-6027.jdwe.live"
              className="px-5 py-2.5 text-sm font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Join the Program
            </a>
          </div>

          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setOpen((v) => !v)}
            aria-label="menu"
          >
            <i
              className={[
                open ? "ri-close-line" : "ri-menu-line",
                "text-2xl",
                scrolled ? "text-foreground-950" : "text-background-50",
              ].join(" ")}
            ></i>
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-6 pt-2 border-t border-background-200/60 rounded-b-2xl bg-background-50">
            <div className="flex flex-col gap-1">
              {NAV_ITEMS.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="px-2 py-3 text-sm font-medium text-foreground-800 hover:text-primary-600 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="https://dna-6027.jdwe.live"
                onClick={() => setOpen(false)}
                className="mt-3 px-5 py-3 text-center text-sm font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 cursor-pointer whitespace-nowrap"
              >
                Join the Program
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}